import { useEffect, useRef } from 'react';

// Measure the sticky AI surface without intercepting native scrolling.
export default function useServiceCardScroll(enabled) {
  const ref = useRef(null);
  useEffect(() => {
    if (!enabled) return;
    const root = ref.current;
    const scroller = root?.closest('main');
    if (!scroller) return;
    const sticky = scroller.querySelector('.fb-ai-sticky-shell');
    const update = () => {
      const inset = sticky?.getBoundingClientRect().height || 60;
      root.style.setProperty('--service-scroll-inset', `${inset}px`);
      scroller.style.setProperty('--service-scroll-inset', `${inset}px`);
    };
    scroller.classList.add('services-soft-snap');
    update();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
    if (sticky) observer?.observe(sticky);
    window.addEventListener('resize', update);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', update);
      root.style.removeProperty('--service-scroll-inset');
      scroller.style.removeProperty('--service-scroll-inset');
      scroller.classList.remove('services-soft-snap');
    };
  }, [enabled]);
  return ref;
}
